@defer (when isUserLoggedIn$ | async) {
  <py-menu-cart-authenticated></py-menu-cart-authenticated>
} @placeholder (minimum 100ms) {
  <py-menu-cart-anonymous></py-menu-cart-anonymous>
}
